import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import Auth from "@aws-amplify/auth";
import { mountReact } from "common";
import { AppConfigService } from "../../services/app-config.service";
import { AuthService } from "../../services/auth.service";
import { Communications } from "./Communications";

@Component({
  selector: "app-portal-shell",
  templateUrl: "./portal-shell.component.html",
  styleUrls: ["./portal-shell.component.scss"]
})
export class PortalShellComponent implements OnInit {
  @ViewChild("communications", { static: true }) containerRef: ElementRef;

  constructor(
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfigService
  ) { }

  public username = "";
  public isDistributor = false;
  public userCanAdminister = false;
  public url_first_segment = "";
  public activeNav = "orders";
  public showCustomerProfile = false;
  public showLandingPage = false;

  ngOnInit() {
    this.username = this.auth.getUsernameAbbreviation();
    this.showCustomerProfile = false;
    this.showLandingPage = false;
    this.isDistributor = this.auth.getUserType() === "distributor";
    this.userCanAdminister =  ["inblock", "superuser"].includes(
      this.auth.getUserType()
    );
    this.setUrl();

    //nav
    this.activeNav = this.router.url.split("/")[1];

    mountReact(this.containerRef, Communications);
  }

  get url() {
    return window.location.pathname;
  }

  get isAdminToolsSelected() {
    const { url } = this;
    return (
      url === "/relationships" ||
      url === "/companies" ||
      url === "/userPermissions" ||
      url.indexOf("/admin_tools/") === 0
    );
  }

  get isCommunicationSelected() {
    const { url } = this;
    return url === "/communications";
  }

  ngOnChange() {
    this.setUrl();
  }

  setUrl() {
    this.url_first_segment = this.route.snapshot["_routerState"].url.split(
      "/"
    )[1];
  }

  logOut(e) {
    e.preventDefault();
    e.stopPropagation();

    try {
      this.auth.removeLocalStorage();
      this.auth.msalLogout();
    } catch (ex) {
      console.log(ex);
    }

    Auth.signOut()
      .then(data => console.log(data))
      .catch(err => console.log(err));

    return true;
  }
}
